import {
  localeSettingsResponseSchema,
  updateLocaleRequestSchema,
  type Locale,
  type LocaleSettingsResponse,
} from '@emr/shared';

import { apiRequest } from './client.ts';

export type { LocaleSettingsResponse };

/** `GET /api/profile/locale` — the caller's own current preference, `null` when unset. */
export function getOwnLocale(signal?: AbortSignal): Promise<LocaleSettingsResponse> {
  return apiRequest(
    '/api/profile/locale',
    localeSettingsResponseSchema,
    signal === undefined ? {} : { signal },
  );
}

/** `PATCH /api/profile/locale` — set the caller's own preference. `null` clears it back to
 * browser-detected. */
export function updateOwnLocale(locale: Locale | null): Promise<LocaleSettingsResponse> {
  const body = updateLocaleRequestSchema.parse({ locale });
  return apiRequest('/api/profile/locale', localeSettingsResponseSchema, {
    method: 'PATCH',
    body,
  });
}
